export default "__VITE_ASSET__D2HitY0r__"